import React, { FC, Fragment } from 'react';

import { Loader } from '@sbu/components.loader';
import { useTagSchemas } from '@sbu/hooks.tags';

import { useTagOptions } from '../useTagOptions';
import { TagEditor, TagEditorProps } from './TagEditor';

type TagEditorContainerProps = Omit<
  TagEditorProps,
  'autocompleteList' | 'tagSchemas'
> & {
  source?: string;
};

export const TagEditorContainer: FC<
  React.PropsWithChildren<TagEditorContainerProps>
> = ({ source, ...rest }) => {
  const { tagSchemas, loading: loadingSchema } = useTagSchemas();
  const { tagOptions, loading: loadingOptions } = useTagOptions(source);

  const loading = loadingSchema || loadingOptions;

  return (
    <Fragment>
      {loading && <Loader size='small' />}
      {!loading && (
        <TagEditor
          autocompleteList={tagOptions}
          source={source}
          tagSchemas={tagSchemas}
          {...rest}
        />
      )}
    </Fragment>
  );
};
